<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ 'dashboard.visuals.addModal.title' | translate }}</h3>
    </div>
    <div class="cardContentStretched">
        <div class="widget-list-container">
            <p>{{ 'dashboard.visuals.addModal.description' | translate }}</p>
            <p class="selected-widgets-text">
                {{
                    widgetSelectionTranslationKey()
                        | translate: { numberOfWidgets: visualsDashboardService.selectedWidgetsForAdding().length }
                }}
            </p>
            <form class="widgets-search" [formGroup]="searchForm">
                <div class="widgets-search-wrapper">
                    <label for="widgetsSearch">
                        <i class="far fa-search"></i>
                    </label>
                    <input
                        type="text"
                        placeholder="{{ 'dashboard.visuals.addModal.search' | translate }}"
                        id="widgetsSearch"
                        formControlName="searchTerm"
                    />
                    @if (searchControlValue() !== '') {
                        <button class="button small transparent icon" (click)="clearSearch()">
                            <i class="far fa-close"></i>
                        </button>
                    }
                </div>
                <div class="widgets-filter-wrapper">
                    <select formControlName="filterValue">
                        @for (option of filterOptions(); track option.value) {
                            <option [value]="option.value">{{ option.label | translate }}</option>
                        }
                    </select>
                </div>
            </form>

            @for (widget of widgetsList(); track widget.widgetId) {
                <app-visual-dashboard-item-picker-item [widget]="widget"></app-visual-dashboard-item-picker-item>
            }
        </div>
    </div>
    <div class="cardFooter">
        <div class="buttonArea centered">
            <button
                class="button primary"
                (click)="confirmSelection()"
                type="button"
                id="confirmVisualDashboardItemPickerModal"
                [title]="'dashboard.visuals.addModal.saveButton' | translate"
            >
                {{ 'dashboard.visuals.addModal.saveButton' | translate }}
            </button>
            <button
                class="button"
                (click)="closeModal()"
                type="button"
                id="closeVisualDashboardItemPickerModal"
                title="{{ 'generalKeywords.close' | translate }}"
            >
                {{ 'generalKeywords.close' | translate }}
            </button>
        </div>
    </div>
</div>
